import { useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import { transformPermissions } from './util';

export function useUserPermissions({ permission }) {
    const user = useSelector(getUser);

    if (!Array.isArray(user?.permissions) || user?.permissions.length === 0) return { read: true, write: true };

    const isPermissionObject = (item) =>
        item &&
        typeof item === 'object' &&
        !Array.isArray(item) &&
        typeof item.resource === 'string' &&
        item.resource.trim() !== '' &&
        Array.isArray(item.actions);

    const filtered = user.permissions.filter(isPermissionObject);

    if (filtered.length === 0) return { read: true, write: true };

    const havePermissions = () => {
        const permissionsMap = transformPermissions(filtered);
        const userPermission = permissionsMap[permission];
        return userPermission;
    };

    return havePermissions();
}
